import { Injectable } from '@angular/core';
import { EQimaAvatarSize, EQimaAvatarType } from '@qima/ngx-qima';

@Injectable({
  providedIn: 'root',
})
export class QimaAvatarService {
  public readonly avatarSize = EQimaAvatarSize;
  public readonly avatarType = EQimaAvatarType;
}
